<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#shared/utils'
import { useVModel } from '@vueuse/core'

const props = defineProps<{
  defaultValue?: string | number
  modelValue?: string | number
  class?: HTMLAttributes['class']
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
})

// Ref per l'elemento input
const inputRef = ref<HTMLInputElement | null>(null)

// Funzione per ripristinare lo zoom quando il campo perde il focus
const handleBlur = () => {
  if (typeof window !== 'undefined' && window.visualViewport) {
    // Ripristina lo zoom a 1.0 dopo un breve delay per permettere al browser di completare il blur
    setTimeout(() => {
      if (window.visualViewport && window.visualViewport.scale !== 1) {
        // Forza il ripristino dello zoom
        document.body.style.zoom = '1'
        setTimeout(() => {
          document.body.style.zoom = ''
        }, 100)
      }
    }, 100)
  }
}

onMounted(() => {
  if (inputRef.value) {
    inputRef.value.addEventListener('blur', handleBlur)
  }
})

onUnmounted(() => {
  if (inputRef.value) {
    inputRef.value.removeEventListener('blur', handleBlur)
  }
})
</script>

<template>
  <input 
    ref="inputRef"
    v-model="modelValue" 
    :class="cn('flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', props.class)"
  >
</template>
